import { autoinject } from "aurelia-framework";
import { bindable } from "aurelia-templating";
import { transient } from "aurelia-dependency-injection";
import { FabMenuItem } from "./fab-menu-item";

@autoinject
@transient()
export class FabMenu {

    private static _openedFabListMenu: FabMenu;

    public isOpen: boolean = false;

    @bindable
    public menuItems: FabMenuItem[];

    @bindable
    public theme: string = "primary";

    @bindable
    disabled: boolean = false;

    @bindable
    icon: string = "more_horiz";

    public constructor() {
    }

    public detached(): void {
        document.removeEventListener("click", this.close, false);
    }

    public toggle = ($event) => {
        this.stopEvent($event);
        if (this.disabled) {
            return;
        }
        const wasOpen = this.isOpen;
        this.isOpen = !this.isOpen;

        if (wasOpen) {
            this.close();
        } else {

            if (FabMenu._openedFabListMenu && FabMenu._openedFabListMenu.isOpen) {
                FabMenu._openedFabListMenu.close();
                FabMenu._openedFabListMenu = null;
            }
            document.removeEventListener("click", this.close, false);
            document.addEventListener("click", this.close, false);
            FabMenu._openedFabListMenu = this;
        }
    }

    public internalClick($event, item, index: number): void {
        this.stopEvent($event);
        if (index > -1 && item && item.click && typeof item.click === "function") {
            item.click(index);
            this.close();
        }
    }

    public close = () => {
        this.isOpen = false;
        if (FabMenu._openedFabListMenu == this) {
            FabMenu._openedFabListMenu = null;
        }
        document.removeEventListener("click", this.close, false);
    }

    private stopEvent(e): void {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.cancelBubble = true;
        e.returnValue = false;
    }
}
